export default "__VITE_ASSET__C4weZ97B__"